// ============================================
// STEP 2: Update ManageAddressesModal Component
// ============================================
// File: src/components/ManageAddressesModal/index.js
// Replace the entire component

import React from 'react';
import useAddressManager from '../Useaddressmanager/useAddressManager';
import AddressModal from '../Addressmodal';

export const ManageAddressesModal = ({ isOpen, onClose, userId }) => {
  const {
    addresses,
    selectedAddress,
    loading,
    error,
    operationInProgress,
    createAddress,
    updateAddress,
    deleteAddress,
    setDefaultAddress,
    selectAddress
  } = useAddressManager(null, userId);

  // Simply render the unified AddressModal
  return (
    <AddressModal
      isOpen={isOpen}
      onClose={onClose}
      addresses={addresses}
      selectedAddress={selectedAddress}
      onSelectAddress={selectAddress}
      onCreateAddress={createAddress}
      onUpdateAddress={updateAddress}
      onDeleteAddress={deleteAddress}
      onSetDefaultAddress={setDefaultAddress}
      loading={loading}
      operationInProgress={operationInProgress}
      isPage={true}
    />
  );
};